import {ValueObject} from '@s-ui/domain'

export class FiltersGroupsListSearchValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static create({value}) {
    return new FiltersGroupsListSearchValueObject({value})
  }

  static createFromSearch({search, type}) {
    // WiP
    return new FiltersGroupsListSearchValueObject({value: []})
  }

  get value() {
    return this.#value.map(filterGroup => filterGroup.value)
  }

  toJSON() {
    return {
      value: this.#value.map(filterGroup => filterGroup.toJSON())
    }
  }
}
